import React, { use, useEffect, useState, useRef } from 'react';
import { useLang } from '../../hook/UseLang';
import { connect } from 'react-redux';
import Slider from 'react-slick';

import './home.css';
//
import CONTENT from '../../contents/home'
const imgArr = [
    './images/home/home_0.jpg',
    './images/home/home_1.jpg',
    './images/home/home_2.jpg',
]
let isInit = false;
function Component(props) {
    // const isAtTop = props.scrollY === 0;
    const [isAtTop, setIsAtTop] = useState(true);
    const [topImgIdx, setTopImgIdx] = useState(0);
    const [lang, setLang] = useLang()
    const sliderRef = useRef()
    useEffect(() => {
        if(isInit) return;
        isInit = true;
        const interval = setInterval(() => {
            setTopImgIdx((prevIdx) => (prevIdx + 1) % 3);
        },[5000])
        return () => clearInterval(interval);
    },[])
    useEffect(() => {
        if(props.scrollY === 0) {
            setIsAtTop(true);
        } else {
            setIsAtTop(false);
        }
    },[props.scrollY]); 
    const settings = {
        dots: true, // Show dots for navigation
        infinite: true, // Enable infinite looping
        speed: 500, // Transition speed
        slidesToShow: 1, // Number of slides to show
        slidesToScroll: 1, // Number of slides to scroll
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        // afterChange: (indexOfCurrentSlide) => {
        //     handleIdxChange(
        //     indexOfCurrentSlide
        //     )
        // },
        dots:false

    };
    // useEffect(() => {
    //     if(!isAtTop){
    //         document.querySelector('.temp-noscroll').style.overflowY = 'hidden';
    //         setTimeout(() => document.querySelector('.temp-noscroll').style.overflowY = 'auto', 700);
    //     }
    // },[isAtTop])
    return (
        <div className='bg-white w-full min-h-[100vh] flex flex-col items-center justify-center pt-[103px] relative' style={{ overflowY: 'auto' }}>
            <link rel="stylesheet" type="text/css" href="http://kenwheeler.github.io/slick/slick/slick-theme.css"/>
            <div className='w-full' style={{ height: isAtTop ? '100vh' : '0vh', transition: 'height 0.5s ease' }}>
            </div>
            <div className="absolute right-[5%] w-[35%] top-[25%] h-[18%] flex justify-center items-center bg-black" style={{ transition: 'all 1s ease', top: isAtTop ? '0%' : '25%', right: isAtTop ? '0%' : '5%', width: isAtTop ? '100%' : '35%', height: isAtTop ? '100%' : '18%' }}>
                <img src={`./images/home/home_0.jpg`} className='h-full w-full absolute' style={{ objectFit: 'cover', top: isAtTop ? '-30%' : '0%'}}></img>
                {isAtTop&&<div className='absolute top-[50vh] text-[#ffffff] text-d-24 font-[600] playfair-display'>{CONTENT.scroll[lang]}</div>}
            </div>
            {/* <div className="absolute right-[5%] w-[35%] top-[25%] h-[18%] flex justify-center items-center bg-black" style={{ transition: 'all 1s ease', top: isAtTop ? '0%' : '25%', right: isAtTop ? '0%' : '5%', width: isAtTop ? '100%' : '35%', height: isAtTop ? '100%' : '18%' }}>
                {isAtTop && <div className='h-full w-full relative' style={{ objectFit: 'cover'}}>
                    <Slider ref={sliderRef} {...{...settings}}>
                        {imgArr.map((src, index) => (
                        <div key={index}>
                            <img className='h-[100%] translate-y-[-30%]' src={src} alt={`Slide ${index}`} style={{objectFit: 'cover'}} />
                        </div>
                        ))}
                    </Slider>
                </div>}
                {!isAtTop && <img src={`./images/home/home_${topImgIdx}.jpg`} className='h-full w-full homechange absolute' style={{ objectFit: 'cover', top: isAtTop ? '-30%' : '0%'}}></img>}

                {isAtTop&&<div className='absolute top-[50vh] text-[#8A827A] text-d-24 font-[600] playfair-display'>{CONTENT.scroll[lang]}</div>}
            </div> */}
            {isAtTop && <div onClick={() => props.scrollRef.current.scrollTop = 1} className='absolute top-[95vh] left-[5%] z-[10] cursor-pointer'>
                <DownArrow />
            </div>}
            <div className='bg-white w-full  flex flex-col items-center justify-center'>
                <div className="w-full grid home-grid">
                    {/* grid1 */}
                    <div className="grid-item-a overflow-y-hidden py-[2vh]">
                        <div className='w-full h-full flex flex-row items-end justify-center'>
                            <div className='relative w-[90%] flex flex-row items-end justify-center'>
                                <div className='text-[10vw] font-[300] tracking-[3vw] text-[#E9E6E1]'>{CONTENT.sec1_0[lang]}</div>
                                <div className='text-[3vw] font-[300] absolute right-0 bottom-[6%] text-[#8A827A] font-[300]'>{CONTENT.sec1_1[lang]}</div>
                            </div>
                        </div>
                    </div>

                    {/* grid3 */}
                    <div className="grid-item-c overflow-y-hidden bg-black relative">
                        <img src='./images/home/sec1_2.jpg' className='h-full w-full' style={{ objectFit: 'cover' }}></img>
                    </div>
                    {/* grid4 */}
                    <div className="grid-item-d row-start-2 overflow-y-hidden relative">
                        <div className='text-[5vw] font-[300] tracking-[1vw] text-[#E9E6E1] absolute bottom-0 right-[10%]'>{CONTENT.sec1_2[lang]}</div>
                    </div>
                    {/* grid5 */}
                    <div className="grid-item-e row-start-3 overflow-y-hidden flex flex-row item-center justify-end">
                        <div className='text-[7vw] font-[300] tracking-[1vw] text-[#8A827A]'>{CONTENT.sec1_3[lang]}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)


const DownArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={10}
        fill="none"
        {...props}
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            d="m1 1 7.586 7.586a2 2 0 0 0 2.828 0L19 1"
        />
    </svg>
)